import { Link, Title } from '@solidjs/meta';
import { useUrls } from 'Shared/SiteProvider';
import { isServer } from 'solid-js/web';
import {OpenSans} from 'Shared/backend/OpenSans';


export function PageMeta()
{
	const urls = useUrls();

	return (<>
		<Title>{!isServer && window.useVite ? '🎸DEV ' : ''} Venue Online Services (VOS)</Title>

		<OpenSans />

		<Link rel='stylesheet' href={urls.buildUrl('resources/fontawesome/css/all.min.css')} />
		<Link rel='stylesheet' href={urls.buildUrl('resources/flatpickr.min.css')} />
	</>);
}


